// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
  width: 100%;
}

.ids-slider {
  display: flex;
  justify-content: center;
}
.ids-slider .tick {
  background-color: var(--ids-slider-tick-color-background-default);
}
.ids-slider .thumb-shadow {
  background-color: var(--ids-slider-thumb-color-shadow-default);
  border-color: var(--ids-slider-thumb-color-border-default);
}
.ids-slider .thumb {
  background-color: var(--ids-slider-thumb-color-background-default);
}
.ids-slider .thumb:hover {
  box-shadow: var(--ids-slider-thumb-shadow-hover);
}
.ids-slider .track {
  background-color: var(--ids-slider-track-color-background-default);
}
.ids-slider .track-progress {
  background-color: var(--ids-slider-track-color-background-progress);
}
.ids-slider:not(.vertical) {
  width: 100%;
}
.ids-slider:not(.vertical) .thumb {
  cursor: ew-resize;
}
.ids-slider.vertical {
  height: 300px;
}
.ids-slider.vertical .thumb {
  cursor: ns-resize;
}
.ids-slider.animated .thumb-draggable {
  transition: transform var(--ids-motion-duration) var(--ids-motion-linear);
}
.ids-slider.animated:not(.vertical) .track-progress {
  transition: transform var(--ids-motion-duration) var(--ids-motion-linear), width var(--ids-motion-duration) var(--ids-motion-linear);
}
.ids-slider.animated.vertical .track-progress {
  transition: transform var(--ids-motion-duration) var(--ids-motion-linear), height var(--ids-motion-duration) var(--ids-motion-linear);
}
.ids-slider.disabled {
  color: var(--ids-slider-color-disabled);
}
.ids-slider.disabled .label {
  cursor: default;
}
.ids-slider.disabled .tick {
  background-color: var(--ids-slider-tick-color-background-disabled);
}
.ids-slider.disabled .thumb-shadow {
  display: none;
}
.ids-slider.disabled .thumb {
  background-color: var(--ids-slider-thumb-color-background-disabled);
  cursor: default;
}
.ids-slider.disabled .thumb:hover {
  box-shadow: none;
}
.ids-slider.disabled .track-area {
  cursor: default;
}
.ids-slider.disabled .track {
  background-color: var(--ids-slider-track-color-background-disabled);
}
.ids-slider.disabled .track-progress {
  background-color: var(--ids-slider-track-color-background-progress-disabled);
}
.ids-slider.readonly {
  color: var(--ids-slider-color-readonly);
}
.ids-slider.readonly .label {
  cursor: default;
}
.ids-slider.readonly .tick {
  background-color: var(--ids-slider-tick-color-background-readonly);
}
.ids-slider.readonly .thumb {
  background-color: var(--ids-slider-thumb-color-background-readonly);
  cursor: pointer;
}
.ids-slider.readonly .thumb-shadow {
  background-color: var(--ids-slider-thumb-color-shadow-readonly);
  border-color: var(--ids-slider-thumb-color-border-readonly);
  cursor: pointer;
}
.ids-slider.readonly .track {
  background-color: var(--ids-slider-track-color-background-readonly);
}
.ids-slider.readonly .track-progress {
  background-color: var(--ids-slider-track-progress-color-background-readonly);
}
.ids-slider.readonly .track-area {
  cursor: default;
}

.slider {
  display: inline-flex;
  position: relative;
  width: 92%;
  margin: 25px 4% 50px;
  justify-content: center;
  align-items: center;
}
.slider.vertical {
  height: 92%;
}
.slider.vertical .tick {
  transform: translate(0, 50%);
}
.slider .tick-container {
  display: flex;
  position: absolute;
  width: 100%;
  align-items: center;
}
.slider .tick-container.vertical {
  height: 100%;
  flex-direction: column;
  align-items: center;
}
.slider .tick {
  display: flex;
  width: var(--ids-slider-tick-size);
  height: var(--ids-slider-tick-size);
  border-radius: var(--ids-border-radius-circle);
  z-index: 40;
  justify-content: center;
  position: absolute;
  transform: translateX(-50%);
}
.slider .label {
  cursor: pointer;
  position: absolute;
  transform: translate(0, 100%);
}
.slider .label::part(text) {
  white-space: nowrap;
}
.slider .label.vertical {
  transform: translate(-50px, -25%);
  min-width: 50px;
  text-align: right;
}
.slider .tooltip {
  background-color: var(--ids-slider-tooltip-color-background);
  color: var(--ids-slider-tooltip-color-text);
  display: flex;
  justify-content: center;
  position: absolute;
  width: auto;
  padding: var(--ids-slider-tooltip-padding);
  height: auto;
  text-align: center;
  margin: auto;
  border-radius: var(--ids-border-radius-2xs);
  vertical-align: middle;
  line-height: 30px;
  max-width: 300px;
  min-width: 32px;
  transition: opacity 0.2s ease;
  opacity: 0;
  bottom: 175%;
  left: -12px;
  user-select: none;
}
.slider .tooltip.vertical {
  bottom: unset;
  left: 200%;
  transform: translate(0, -25%);
}
.slider .tooltip .pin {
  position: absolute;
  width: 0;
  height: 0;
  bottom: -6px;
  margin-top: 1px;
  left: 14px;
  border-left: 6px solid transparent;
  border-top: 6px solid var(--ids-slider-tooltip-color-background);
  border-right: 6px solid transparent;
}
.slider .tooltip .pin.vertical {
  left: unset;
  bottom: unset;
  margin-top: unset;
  border-top: 6px solid transparent;
  border-right: 6px solid var(--ids-slider-tooltip-color-background);
  border-bottom: 6px solid transparent;
  right: 100%;
  transform: translate(0, 10px);
}
.slider .thumb-draggable {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  outline: none;
  position: absolute;
  inset-inline: var(--inset-inline-start);
}
.slider .thumb {
  width: var(--ids-slider-thumb-size);
  height: var(--ids-slider-thumb-size);
  border-radius: 50%;
  z-index: 50;
}
.slider .thumb-shadow {
  position: absolute;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border-width: var(--ids-space-4xs);
  border-style: solid;
  transition: transform var(--ids-motion-duration) var(--ids-motion-linear);
  transform: scale(0);
}
.slider .thumb-shadow.active {
  transform: scale(1);
}
.slider .track-area {
  width: 100%;
  height: var(--ids-space-md);
  background-color: var(--ids-color-transparent);
  align-items: center;
  justify-content: center;
  display: flex;
  position: absolute;
  z-index: 50;
  cursor: pointer;
}
.slider .track-area.vertical {
  height: 100%;
  width: var(--ids-space-md);
}
.slider .track {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: var(--ids-space-2xs);
  width: calc(100% - var(--ids-slider-thumb-size) / 2);
  position: absolute;
  z-index: 30;
  border-radius: var(--ids-border-radius-2xs);
}
.slider .track.vertical {
  justify-content: center;
  width: var(--ids-space-2xs);
  height: calc(100% - var(--ids-slider-thumb-size) / 2);
}
.slider .track .track-progress {
  height: inherit;
  position: absolute;
  /* stylelint-disable-next-line custom-property-pattern */
  width: calc((var(--percentEnd) - var(--percentStart)) * 1%);
}
.slider .track .track-progress.vertical {
  /* stylelint-disable-next-line custom-property-pattern */
  height: calc((var(--percentEnd) - var(--percentStart)) * 1%);
  width: 100%;
  bottom: 0%;
}

:host([dir=rtl]) .slider:not(.vertical) .tick {
  transform: translateX(50%);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-slider/ids-slider.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;AADF;AAGE;EACE,iEAAA;AADJ;AAIE;EACE,8DAAA;EACA,0DAAA;AAFJ;AAKE;EACE,kEAAA;AAHJ;AAKI;EACE,gDAAA;AAHN;AAOE;EACE,kEAAA;AALJ;AAQE;EACE,mEAAA;AANJ;AAUE;EACE,WAAA;AARJ;AAUI;EACE,iBAAA;AARN;AAaE;EACE,aAAA;AAXJ;AAaI;EACE,iBAAA;AAXN;AAiBI;EACE,yEAAA;AAfN;AAmBM;EACE,oIACE;AAlBV;AAwBM;EACE,qIACE;AAvBV;AA8BE;EACE,uCAAA;AA5BJ;AA8BI;EACE,eAAA;AA5BN;AA+BI;EACE,kEAAA;AA7BN;AAgCI;EACE,aAAA;AA9BN;AAiCI;EACE,mEAAA;EACA,eAAA;AA/BN;AAiCM;EACE,gBAAA;AA/BR;AAmCI;EACE,eAAA;AAjCN;AAoCI;EACE,mEAAA;AAlCN;AAqCI;EACE,4EAAA;AAnCN;AAwCE;EACE,uCAAA;AAtCJ;AAwCI;EACE,eAAA;AAtCN;AAyCI;EACE,kEAAA;AAvCN;AA0CI;EACE,mEAAA;EACA,eAAA;AAxCN;AA2CI;EACE,+DAAA;EACA,2DAAA;EACA,eAAA;AAzCN;AA4CI;EACE,mEAAA;AA1CN;AA6CI;EACE,4EAAA;AA3CN;AA8CI;EACE,eAAA;AA5CN;;AAiDA;EACE,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AA9CF;AAgDE;EACE,WAAA;AA9CJ;AAgDI;EACE,4BAAA;AA9CN;AAkDE;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAhDJ;AAkDI;EACE,YAAA;EACA,sBAAA;EACA,mBAAA;AAhDN;AAoDE;EACE,aAAA;EACA,kCAAA;EACA,mCAAA;EACA,8CAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,2BAAA;AAlDJ;AAqDE;EACE,eAAA;EACA,kBAAA;EACA,6BAAA;AAnDJ;AAqDI;EACE,mBAAA;AAnDN;AAsDI;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;AApDN;AAwDE;EACE,4DAAA;EACA,2CAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,2CAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAtDJ;AAwDI;EACE,aAAA;EACA,UAAA;EACA,6BAAA;AAtDN;AAyDI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,kCAAA;EACA,gEAAA;EACA,mCAAA;AAvDN;AAyDM;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iCAAA;EACA,kEAAA;EACA,oCAAA;EACA,WAAA;EACA,6BAAA;AAvDR;AA4DE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,uCAAA;AA1DJ;AA6DE;EACE,mCAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;AA3DJ;AA8DE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,yEAAA;EACA,mBAAA;AA5DJ;AA8DI;EACE,mBAAA;AA5DN;AAgEE;EACE,WAAA;EACA,2BAAA;EAMA,8CAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAnEJ;AAwDI;EACE,YAAA;EACA,0BAAA;AAtDN;AAkEE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,oDAAA;EAOA,kBAAA;EACA,WAAA;EACA,2CAAA;AAtEJ;AA8DI;EACE,uBAAA;EACA,2BAAA;EACA,qDAAA;AA5DN;AAmEI;EACE,eAAA;EACA,kBAAA;EACA,wDAAA;EACA,2DAAA;AAjEN;AAmEM;EACE,wDAAA;EACA,4DAAA;EACA,WAAA;EACA,UAAA;AAjER;;AAwEE;EACE,0BAAA;AArEJ","sourcesContent":["@use '../../themes/mixins/ids-core-mixins' as *;\n\n:host {\n  position: relative;\n  width: 100%;\n}\n\n.ids-slider {\n  display: flex;\n  justify-content: center;\n\n  .tick {\n    background-color: var( --ids-slider-tick-color-background-default);\n  }\n\n  .thumb-shadow {\n    background-color: var(--ids-slider-thumb-color-shadow-default);\n    border-color: var(--ids-slider-thumb-color-border-default);\n  }\n\n  .thumb {\n    background-color: var(--ids-slider-thumb-color-background-default);\n\n    &:hover {\n      box-shadow: var(--ids-slider-thumb-shadow-hover);\n    }\n  }\n\n  .track {\n    background-color: var(--ids-slider-track-color-background-default);\n  }\n\n  .track-progress {\n    background-color: var(--ids-slider-track-color-background-progress);\n  }\n\n  // horizontal slider rules only\n  &:not(.vertical) {\n    width: 100%;\n\n    .thumb {\n      cursor: ew-resize;\n    }\n  }\n\n  // Vertical slider rules only\n  &.vertical {\n    height: 300px;\n\n    .thumb {\n      cursor: ns-resize;\n    }\n  }\n\n  // Animates some parts of the shadow root when applied to the `.container` element\n  &.animated {\n    .thumb-draggable {\n      transition: transform var(--ids-motion-duration) var(--ids-motion-linear);\n    }\n\n    &:not(.vertical) {\n      .track-progress {\n        transition:\n          transform var(--ids-motion-duration) var(--ids-motion-linear),\n          width var(--ids-motion-duration) var(--ids-motion-linear);\n      }\n    }\n\n    &.vertical {\n      .track-progress {\n        transition:\n          transform var(--ids-motion-duration) var(--ids-motion-linear),\n          height var(--ids-motion-duration) var(--ids-motion-linear);\n      }\n    }\n  }\n\n  // Disabled cursor rules\n  &.disabled {\n    color: var(--ids-slider-color-disabled);\n\n    .label {\n      cursor: default;\n    }\n\n    .tick {\n      background-color: var(--ids-slider-tick-color-background-disabled);\n    }\n\n    .thumb-shadow {\n      display: none;\n    }\n\n    .thumb {\n      background-color: var(--ids-slider-thumb-color-background-disabled);\n      cursor: default;\n\n      &:hover {\n        box-shadow: none;\n      }\n    }\n\n    .track-area {\n      cursor: default;\n    }\n\n    .track {\n      background-color: var(--ids-slider-track-color-background-disabled);\n    }\n\n    .track-progress {\n      background-color: var(--ids-slider-track-color-background-progress-disabled);\n    }\n  }\n\n  // Readonly cursor rules\n  &.readonly {\n    color: var(--ids-slider-color-readonly);\n\n    .label {\n      cursor: default;\n    }\n\n    .tick {\n      background-color: var(--ids-slider-tick-color-background-readonly);\n    }\n\n    .thumb {\n      background-color: var(--ids-slider-thumb-color-background-readonly);\n      cursor: pointer;\n    }\n\n    .thumb-shadow {\n      background-color: var(--ids-slider-thumb-color-shadow-readonly);\n      border-color: var(--ids-slider-thumb-color-border-readonly);\n      cursor: pointer;\n    }\n\n    .track {\n      background-color: var(--ids-slider-track-color-background-readonly);\n    }\n\n    .track-progress {\n      background-color: var(--ids-slider-track-progress-color-background-readonly);\n    }\n\n    .track-area {\n      cursor: default;\n    }\n  }\n}\n\n.slider {\n  display: inline-flex;\n  position: relative;\n  width: 92%; // horizontal\n  margin: 25px 4% 50px;\n  justify-content: center;\n  align-items: center;\n\n  &.vertical {\n    height: 92%; // vertical\n\n    .tick {\n      transform: translate(0, 50%);\n    }\n  }\n\n  .tick-container {\n    display: flex;\n    position: absolute;\n    width: 100%; // horizontal\n    align-items: center;\n\n    &.vertical {\n      height: 100%; // vertical\n      flex-direction: column; // vertical\n      align-items: center; // vertical\n    }\n  }\n\n  .tick {\n    display: flex;\n    width: var(--ids-slider-tick-size);\n    height: var(--ids-slider-tick-size);\n    border-radius: var(--ids-border-radius-circle);\n    z-index: 40;\n    justify-content: center;\n    position: absolute;\n    transform: translateX(-50%);\n  }\n\n  .label {\n    cursor: pointer;\n    position: absolute;\n    transform: translate(0, 100%); // horiz\n\n    &::part(text) {\n      white-space: nowrap;\n    }\n\n    &.vertical {\n      transform: translate(-50px, -25%); // vert\n      min-width: 50px; // vert\n      text-align: right; // vert\n    }\n  }\n\n  .tooltip {\n    background-color: var(--ids-slider-tooltip-color-background);\n    color: var(--ids-slider-tooltip-color-text);\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    width: auto;\n    padding: var(--ids-slider-tooltip-padding);\n    height: auto;\n    text-align: center;\n    margin: auto;\n    border-radius: var(--ids-border-radius-2xs);\n    vertical-align: middle;\n    line-height: 30px;\n    max-width: 300px;\n    min-width: 32px;\n    transition: opacity 0.2s ease;\n    opacity: 0;\n    bottom: 175%; // horizontal\n    left: -12px; // horizontal\n    user-select: none;\n\n    &.vertical {\n      bottom: unset;\n      left: 200%;\n      transform: translate(0, -25%);\n    }\n\n    .pin {\n      position: absolute;\n      width: 0;\n      height: 0;\n      bottom: -6px; // horizontal\n      margin-top: 1px; // horizontal\n      left: 14px; // horizontal\n      border-left: 6px solid transparent; // horizontal\n      border-top: 6px solid var(--ids-slider-tooltip-color-background); // horizontal\n      border-right: 6px solid transparent; // horizontal\n\n      &.vertical {\n        left: unset;\n        bottom: unset;\n        margin-top: unset;\n        border-top: 6px solid transparent;\n        border-right: 6px solid var(--ids-slider-tooltip-color-background);\n        border-bottom: 6px solid transparent;\n        right: 100%;\n        transform: translate(0, 10px);\n      }\n    }\n  }\n\n  .thumb-draggable {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    outline: none;\n    position: absolute;\n    inset-inline: var(--inset-inline-start);\n  }\n\n  .thumb {\n    width: var(--ids-slider-thumb-size);\n    height: var(--ids-slider-thumb-size);\n    border-radius: 50%;\n    z-index: 50;\n  }\n\n  .thumb-shadow {\n    position: absolute;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    border-width: var(--ids-space-4xs);\n    border-style: solid;\n    transition: transform var(--ids-motion-duration) var(--ids-motion-linear);\n    transform: scale(0);\n\n    &.active {\n      transform: scale(1);\n    }\n  }\n\n  .track-area {\n    width: 100%; // horizontal\n    height: var(--ids-space-md); // horizontal\n    &.vertical {\n      height: 100%; // vert\n      width: var(--ids-space-md); // vert\n    }\n\n    background-color: var(--ids-color-transparent);\n    align-items: center; // horizontal\n    justify-content: center; // vertical\n    display: flex;\n    position: absolute;\n    z-index: 50;\n    cursor: pointer;\n  }\n\n  .track {\n    display: flex;\n    align-items: center; // horizontal\n    justify-content: flex-start; // horizontal\n    height: var(--ids-space-2xs); // horizontal\n    width: calc(100% - (var(--ids-slider-thumb-size) / 2)); // horizontal\n    &.vertical {\n      justify-content: center; // vertical\n      width: var(--ids-space-2xs); // vert\n      height: calc(100% - (var(--ids-slider-thumb-size) / 2)); // vert\n    }\n\n    position: absolute;\n    z-index: 30;\n    border-radius: var(--ids-border-radius-2xs);\n\n    .track-progress {\n      height: inherit;\n      position: absolute;\n      /* stylelint-disable-next-line custom-property-pattern */\n      width: calc((var(--percentEnd) - var(--percentStart)) * 1%); // horiz\n\n      &.vertical {\n        /* stylelint-disable-next-line custom-property-pattern */\n        height: calc((var(--percentEnd) - var(--percentStart)) * 1%); // vert\n        width: 100%; // vert\n        bottom: 0%; // vert\n      }\n    }\n  }\n}\n\n:host([dir='rtl']) {\n  .slider:not(.vertical) .tick {\n    transform: translateX(50%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
